<wbo-edit-page #editPage [formGroup]="editPage.formGroup" [title]="model.data.name" (addingAnother)="addingAnother($event)">
    <fui-formation-group-template *formationGroup="{title: 'wbo.composite-option-group.edit.formation.details', formControlNames: ''}">
        <fui-rows>
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    <ng-container formGroupName="primaryCategory">
                        <wbo-category-single-select-edit-control formControlName="categoryId"
                                                                 [(ngModel)]="model.data.primaryCategory.categoryId"
                                                                 [objectValue]="model.data.primaryCategory">
                        </wbo-category-single-select-edit-control>
                    </ng-container>
                    <wbo-image-edit-control formControlName="icon" [(ngModel)]="model.data.icon">
                    </wbo-image-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-text-edit-control formControlName="externalName" [(ngModel)]="model.data.externalName"></wbo-text-edit-control>
                    <wbo-textarea-edit-control formControlName="description" [(ngModel)]="model.data.description">
                    </wbo-textarea-edit-control>
                    <wbo-checkbox-edit-control formControlName="promptForPlgSelections"
                                               [(ngModel)]="model.data.promptForPlgSelections"></wbo-checkbox-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.composite-option-group.edit.formation.products', formControlNames: 'sellableLines'}">
        <fui-rows>
            <fui-columns>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.sellableLines" [editable]="true" [removable]="true"
                                   [entityPath]="'sellableLines'" (saved)="sellableLineSaved($event)"
                                   [reorderable]="true">
                        <wbo-sellable-edit-link-column field="sellable.name"
                                                       [editMode]="EditMode.VIEW"
                                                       componentPath="sellable"></wbo-sellable-edit-link-column>
                        <wbo-text-column field="sellable.plu"></wbo-text-column>
                        <wbo-checkbox-column field="available"></wbo-checkbox-column>
                        <wbo-currency-column field="sellable.price"></wbo-currency-column>
                        <wbo-currency-column field="additionalPrice" [editable]="true"></wbo-currency-column>
                        <wbo-checkbox-column field="defaultSellable" [editable]="true"></wbo-checkbox-column>
                        <wbo-edit-grid-add-row [identifierField]="'sellableId'" [componentPath]="'sellable'">
                            <wbo-edit-grid-add-row-quick-add>
                                <wbo-sellable-single-select-edit-control></wbo-sellable-single-select-edit-control>
                            </wbo-edit-grid-add-row-quick-add>
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-search [title]="'wbo.composite-option-group.edit.grid-add.products.addProductLines'"
                                                              [searchComponent]="ProductLineSearchPageComponent"></wbo-edit-grid-add-row-search>
                                <wbo-edit-grid-add-row-new-entity
                                    [title]="'wbo.composite-option-group.edit.grid-add.products.newProductLine'"
                                    [editComponent]="ProductLineEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-columns>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
